import React, { useEffect, useRef, useState } from "react";
import "../Style/appdev.css";

import ServicesSection from "../components/appservices";
import ProcessSection from "../components/appdevprocess";
import FutureSection from "../components/appdevfuture";
import MobileAppTrends from "../components/apptrends";
import AppBenefits from "../components/appdevbenefits";
import DevStack from "../components/appdevstack";
import FormsSection from "../components/Forms";
import DoubtsSection from "../components/appdevdoubts";
import FeedbackSection from "../components/Clientfeedback";
import PageFooter from "../components/Footer";

function AppdevPage() {
  const overlayRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (overlayRef.current) observer.observe(overlayRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="appdev-page">
        {/* CSS-only pattern layers, no images */}
        <div className="appdev-grid-pattern" aria-hidden="true" />
        <div className="appdev-blob appdev-blob-1" aria-hidden="true" />
        <div className="appdev-blob appdev-blob-2" aria-hidden="true" />
        <div className="appdev-blob appdev-blob-3" aria-hidden="true" />

        <div
          className={`appdev-overlay ${isVisible ? "appdev-visible" : ""}`}
          ref={overlayRef}
        >
          <div className="appdev-glass">
            {/* <img
              src={mpeoplesLogo}
              alt="MPeoples Logo"
              className="appdev-logo appdev-anim appdev-anim-1"
            /> */}

            <span className="appdev-eyebrow appdev-anim appdev-anim-2">
              Mobile App Development Services
            </span>

            <h1 className="appdev-title appdev-anim appdev-anim-3">
              Custom Mobile App Development Services for Modern Businesses
            </h1>

          <p className="appdev-description appdev-anim appdev-anim-4">
  At MPeoples, we build high-performance mobile applications that
  combine intuitive UI/UX design, robust functionality, and scalable
  architecture. Our custom mobile app development services help
  startups, enterprises, and growing businesses deliver exceptional
  user experiences on Android, iOS, and cross-platform environments
  while accelerating digital transformation.
</p>

<a
  href="tel:+919876543210"
  className="appdev-btn appdev-anim appdev-anim-5"
>
  Let&rsquo;s Build Together <span>↗</span>
</a>
          </div>
        </div>
      </section>

      <ServicesSection />
      <ProcessSection />
      <FutureSection />
      <MobileAppTrends />
      <AppBenefits />
      <DevStack />
      <FormsSection />
      <DoubtsSection />
      <FeedbackSection />
      <PageFooter />
    </>
  );
}

export default AppdevPage;